export default __webpack_public_path__ + "static/logoWhite-7bd1d3a2e8a13532f649f29522eda242.svg";